import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '~/components';
import MyOpportunitiesGrid from './components/MyOpportunitiesGrid';
import { OpportunityFilters, useFilters, } from '~/components/OpportunityFilters/OpportunityFilters';
import { useState } from 'react';
const MyOpportunitiesPage = ({ preloadCount = 9, sections, maxLoadCount = 9, }) => {
    var _a;
    const { searchParams, setSearchParams, searchItem, setSearchItem, searchQuery, setSearchQuery, country, setCountry, industry, setIndustry, } = useFilters();
    // Callback function to handle filter changes
    const handleFilterChange = ({ industry, country, searchItem, }) => {
        setSearchItem(searchItem);
        setCountry(country);
        setIndustry(industry);
    };
    const InterestedInTypes = {
        NONE: 0,
        CONTACT: 1,
        COLLECTION: 2,
    };
    const [interestedInType, setInterestedInType] = useState(Number(searchParams.get('interestedInType')) || 1);
    const handleInterestedInTypeChange = (type) => {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set('interestedInType', type.toString());
            return params;
        });
        setInterestedInType(type);
    };
    const contentTypeIds = sections && sections.map((sections) => sections.contentTypes).flat();
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "page-elements__actions container" }, { children: [_jsx(OpportunityFilters, { contentTypes: contentTypeIds, onFilterChange: handleFilterChange, searchQuery: [searchQuery, setSearchQuery], setSearchItem: setSearchItem }), _jsxs("div", Object.assign({ className: "page-elements__actions__interested-in" }, { children: [_jsx(Button, Object.assign({ variant: interestedInType == InterestedInTypes.CONTACT
                                    ? 'primary'
                                    : 'secondary', className: "", onClick: () => handleInterestedInTypeChange(InterestedInTypes.CONTACT) }, { children: "CONTACT ME" })), _jsx(Button, Object.assign({ variant: interestedInType == InterestedInTypes.COLLECTION
                                    ? 'primary'
                                    : 'secondary', onClick: () => handleInterestedInTypeChange(InterestedInTypes.COLLECTION) }, { children: "SAVED" }))] }))] })), _jsx("div", Object.assign({ className: "page-elements__results container" }, { children: _jsx(MyOpportunitiesGrid, { limit: preloadCount, searchQuery: (_a = searchItem === null || searchItem === void 0 ? void 0 : searchItem.name) !== null && _a !== void 0 ? _a : '', country: country.value, industry: industry.value, maxLoadCount: maxLoadCount, sections: sections, interestedInType: interestedInType }) }))] }));
};
export default MyOpportunitiesPage;
